import { createContext, useContext } from "react";
import type { StoreScope } from "@/api/queries/keys";
import type { Me, StoreAccess } from "@/api/types";

export interface StoreContextValue {
  me: Me;
  organization: Me["organization"];
  /** Stores the backend says this user may access. */
  stores: StoreAccess[];
  /** Selected store, or null for "All stores" (only offered with 2+ stores). */
  activeStore: StoreAccess | null;
  scope: StoreScope;
  /** The URL's store segment: the active store id, or "ALL". */
  storeParam: string;
  multiStore: boolean;
  setActiveStore: (storeId: string | null) => void;
  switchOrganization: (organizationId: string) => Promise<void>;
}

export const StoreContext = createContext<StoreContextValue | null>(null);

export function useStoreContext(): StoreContextValue {
  const ctx = useContext(StoreContext);
  if (!ctx) throw new Error("useStoreContext must be used inside <StoreProvider>");
  return ctx;
}

/** Query-key scope for store-scoped lists ("all" or a storeId). */
export function useStoreScope(): StoreScope {
  return useStoreContext().scope;
}

/** The `$store` URL segment of this tab, for links: `<Link to="/$store/…" params={{ store }} />`. */
export function useStoreParam(): string {
  return useStoreContext().storeParam;
}
